// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.blocto",
    name: "Blocto",
    homepage: "https://blocto.io/",
    image_id: "374258d3-c749-4f37-7815-77e61f798c00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/id1481181682",
        android: "https://play.google.com/store/apps/details?id=com.portto.blocto&hl=en&gl=US",
        mac: "",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "blocto://",
        universal: "https://blocto.app",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map